<template>
  <v-timeline-item
    :color="time.Color"
    small
  >
    <v-row class="pt-1">
      <v-col cols="3">
        <custom-time-picker
          v-model="time.Time"
          @input="handleChangeTime"
        />
        <custom-color-picker
          :color="time.Color"
          :onChangeColor="handleChangeColor"
          :icon="'mdi-format-color-fill'"
        />
        <br>
        <v-btn
          dark
          color="red"
          @click="handleDelete"
        >
          {{$t('common.delete')}}
        </v-btn>
      </v-col>
      <v-col>
        <translate
          v-model="time.Title"
          :languages="languages"
          :label="$t('timeline.title')"
          @input="handleChangeIsModified"
          style="padding: 0 10px 0 10px;"
        />
        <translate
          v-model="time.Description"
          type="textArea"
          :languages="languages"
          :label="$t('timeline.description')"
          @input="handleChangeIsModified"
          style="padding: 0 10px 0 10px;"
        />
      </v-col>
    </v-row>
    <v-divider />
  </v-timeline-item>
</template>

<script>
  import {
    mapState
  } from 'vuex'
  import _ from 'lodash'
  import CustomTimePicker from '@/components/CustomTimePicker'
  import CustomColorPicker from '@/components/CustomColorPicker'
  import Translate from '@/components/Translate'
  export default {
    components: {
      CustomTimePicker,
      CustomColorPicker,
      Translate
    },
    props: {
      time: {
        type: Object,
        required: true
      },
      onDelete: {
        type: Function,
        required: false,
        default: null
      }
    },
    data: () => ({
      showConfirmDelete: false
    }),
    computed: {
      ...mapState('app',[]),
      languages () {
        return this.$store.state.app.Languages
      }
    },
    methods: {
      handleDelete () {
        this.onDelete(this.time.ID)
      },
      handleAddTime () {
        this.handleChangeIsModified()
        this.content.Times.push({
          ID: `new_${_.uniqueId()}`,
          Time: '12:00',
          Title: { es: '' },
          Description: { es: ''},
          Color: '#123123'
        })
      },
      handleChangeTime () {
        this.handleChangeIsModified()
      },
      handleChangeColor (color) {
        this.time.Color = color
        this.handleChangeIsModified()
      },
      handleChangeIsModified () {
        this.$store.state.app.isModified = true
      }
    }
  }
</script>

<style scoped>
</style>

